<template>
    <div class="layout">

        <main class="app-content p-4">
            <div class="app-page">
                <router-view />
            </div>
        </main>

    </div>
</template>

<script>
    export default {
        name: "EmptyLayout"
    }
</script>

<style scoped>

</style>
